import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Warehouse } from '../../models/warehouse.ts/warehouse';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class WarehouseProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/warehouse';

  public getwarehouseproxyById(id: string): Observable<ApiResponse<Warehouse>> {
    return this.httpClient.get<ApiResponse<Warehouse>>(`${this.baseUrl}/${id}`);
  }

  public getAllWarehouses(): Observable<ApiResponse<Warehouse[]>> {
    return this.httpClient.get<ApiResponse<Warehouse[]>>(`${this.baseUrl}/all`);
  }
}
